<div class="policy-link-cards margin-bottom-xmedium" [ngClass]="{'policy-link-cards--group': config?.layout === 'group', 'policy-link-cards--list': config?.layout === 'list'}" *ngIf="data && data.length">
  <h3 class="margin-bottom-small h3-heading" *ngIf="config?.title">{{config?.title}}</h3>
  <div class="policy-link-cards-content">
    <div class="policy-link-cards-container flex" [ngClass]="config?.layout === 'list' ? 'flex-row flex-wrap' : 'flex-column'">
      <div class="policy-link-card flex" *ngFor="let dataItem of data; let i = index">
        <div class="policy-link-card-content flex flex-row width-100">
          <div class="policy-link-card-details margin-right-xsmall">
            <div class="flex flex-row flex-items-center">
              <open-svg-icon [name]="dataItem.icon" size="large" *ngIf="dataItem.icon"></open-svg-icon>
              <div [ngClass]="{'margin-left-xxsmall': dataItem.icon}">
                <p class="body margin-none policy-link-card-details-title">{{dataItem.name}}</p>
                <p class="small margin-none" *ngIf="dataItem.description">{{dataItem.description}}</p>
              </div>
            </div>
            <p class="small policy-link-card-details-summary margin-none">{{dataItem.summary}}</p>
          </div>
          <div class="policy-link-card-action flex flex-items-end flex-justify-center flex-column">
            <open-badge class="policy-link-card-badge" *ngIf="dataItem.status" [label]="dataItem.status" [variant]="dataItem.variant"></open-badge>
            <div class="flex flex-items-center link-button" *ngIf="dataItem.linkType" [ngClass]="{'policy-link-card-buttons': dataItem.linkType, 'policy-link-disabled': !dataItem.linkType }" (click)="dataItem.linkType && clickEvent(dataItem)">
              <ng-container class="link-button-download" *ngIf="dataItem.linkType === 'download'; else linkTemplate">
                <mat-icon class="file_download material-icons-outlined margin-right-tiny mat-icon"></mat-icon>
                <a class="small">Download</a>
              </ng-container>
              <ng-template #linkTemplate>
                <mat-icon *ngIf="isIntercomEnabled || dataItem.linkType === 'claim'" class="east material-icons-outlined margin-right-tiny mat-icon"></mat-icon>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <div class="policy-link-cards-footnote" *ngIf="config?.footnote && isIntercomEnabled" [innerHTML]="config?.footnote"></div>
    </div>
  </div>
</div>
